import React, { useState } from 'react';
import SovosButton from "mosaic-react/sovos-button";
import SovosDialog from "mosaic-react/sovos-dialog";
import SovosDialogActions from "mosaic-react/sovos-dialog-actions";
import SovosDialogContent from "mosaic-react/sovos-dialog-content";
import SovosDialogTitle from "mosaic-react/sovos-dialog-title";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import RelatedEntitiesTree from './RelatedEntitiesTree';

const OtherEntitiesDialog = ({ isOpen, setIsOpen, otherEntities, organizationId, applyRelatedEntitiesAction }) => {
    const { i18n, pushNotification, reload } = useGlobalValue();
    const [selectedItems, setSelectedItems] = useState({});
  
    return (
        <SovosDialog 
            open={isOpen} 
            onClose={() => setIsOpen(false)}
            maxWidth="sm"
            fullWidth
        >
            <SovosDialogTitle sx={{fontSize: 25}} showCloseButton onClose={() => setIsOpen(false)}>
                {i18n`Affected Entities`}
            </SovosDialogTitle>
            <SovosDialogContent>
                <RelatedEntitiesTree entitiesByCombination={otherEntities} setSelectedItems={setSelectedItems} />
            </SovosDialogContent>
            <SovosDialogActions>
                <SovosButton 
                    variant="contained" 
                    onClick={() => setIsOpen(false)}
                >
                    {i18n`Close`}
                </SovosButton>
                <SovosButton 
                    variant="contained" 
                        onClick={async () => {
                            const res = await applyRelatedEntitiesAction(organizationId, selectedItems, setIsOpen)
                            setIsOpen(false)
                            if (!res?.apply_related_entities_to_translations) {
                                pushNotification({
                                    open: true,
                                    message: `Somethings went wrong`,
                                    type: "error",
                                    timeout: "short",
                                });
                                return
                            }

                            pushNotification({
                                open: true,
                                message: `Your changes have been successfully saved.`,
                                type: "confirmation",
                                timeout: "short",
                            });
                            reload && reload();
                        }}
                >
                    {i18n`Save`}
                </SovosButton>
            </SovosDialogActions>
        </SovosDialog>
    );
};

export default OtherEntitiesDialog; 